import React from "react";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@mui/material/styles";
import EstadoPedidoBadge from "./EstadoPedidoBadge";
import { detalleEsAlerta } from "../../helpers/turnos";

const SIN_DATO = "—";

// Keyframes propios: sustituyen a la clase global blink-alert del legacy
const parpadeo = keyframes`
    0%, 100% { background-color: #fdece9; }
    50% { background-color: #ffffff; }
`;

const sxContenedor = { mt: 2, pt: 1.5, borderTop: "1px solid #dee2e6", textAlign: "left" };
const sxBase = { mb: 1, p: 1, borderRadius: 1, color: "#212529" };
const sxPreparado = { ...sxBase, backgroundColor: "#f8f9fa", border: "1px solid #dee2e6" };
const sxAlerta = {
    ...sxBase,
    border: "2px solid #dc3545",
    animation: `${parpadeo} 1s ease-in-out infinite`,
    "@media (prefers-reduced-motion: reduce)": { animation: "none", backgroundColor: "#fdece9" },
};
const sxEtiqueta = { fontWeight: 700, color: "#495057" };

const Campo = ({ etiqueta, children }) => (
    <Typography variant="body2" component="div">
        <Box component="span" sx={sxEtiqueta}>{etiqueta}:</Box> {children}
    </Typography>
);

/**
 * Lista los pedidos (detalles) de un turno; los no preparados parpadean en rojo
 */
const DetallesTurno = ({ detalles }) => {
    if (!Array.isArray(detalles) || detalles.length === 0) return null;
    return (
        <Box sx={sxContenedor}>
            {detalles.map((d, indice) => (
                <Box key={d?.pedido ?? `detalle-${indice}`} sx={detalleEsAlerta(d?.estado) ? sxAlerta : sxPreparado}>
                    <Campo etiqueta="Pedido">{d?.pedido ?? SIN_DATO}</Campo>
                    <Campo etiqueta="Estado"><EstadoPedidoBadge estado={d?.estado} /></Campo>
                    <Campo etiqueta="Preparador">{d?.preparador ?? SIN_DATO}</Campo>
                    <Campo etiqueta="Ubicación">{d?.ubicacion ?? SIN_DATO}</Campo>
                </Box>
            ))}
        </Box>
    );
};

export default React.memo(DetallesTurno);
